export var FIELD_META_PROP = 'data-__meta';
export var FIELD_DATA_PROP = 'data-__field';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_compatible@1.0.2@@ant-design/compatible/es/form/constants.js
// module id = 284
// module chunks = 0